import React from "react";

function Footer()
{
    return (
        <footer class="p-4 border-2 border-inherit shadow-lg font-light">
            <span>
                All Rights Reserved, &copy; 2022 HCMUwUS
            </span>
        </footer>
    )
}

export default Footer